// ============================================
// PAGE - Descarga versión de escritorio (pública)
// ============================================

import { Link } from 'react-router-dom';
import { FaWindows } from 'react-icons/fa';
import { MdHome } from 'react-icons/md';
import { useRegistrarDescarga } from '@almacenes/core';
import pcstoreIllustration from '@/assets/images/pcstore.svg';

const HERO_GRADIENT =
  'linear-gradient(135deg, #0a1628 0%, #0e1f3d 25%, #1a3060 50%, #0e1f3d 75%, #0a1628 100%)';

const DESKTOP_APP_VERSION = '1.2.3'; // 👈 Actualiza esta versión cuando subas una nueva release
const DESKTOP_APP_DOWNLOAD_URL =
  `https://storage.googleapis.com/almacenes-digitales-public/desktop/Almacenes_Digitales_${DESKTOP_APP_VERSION}.exe`;

export const DescargaEscritorioPage = () => {
  const { mutate: registrarDescarga } = useRegistrarDescarga();

  const handleDownloadClick = () => {
    // Registrar descarga de forma asíncrona sin bloquear
    registrarDescarga({
      version: DESKTOP_APP_VERSION,
      sistemaOperativo: 'windows',
    });
  };
  return (
    <div
      className="relative flex min-h-screen items-center overflow-hidden px-6 py-20"
      style={{ background: HERO_GRADIENT }}
    >
      <Link
        to="/"
        title="Ir al inicio"
        className="absolute left-6 top-6 flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white backdrop-blur-sm transition-colors hover:bg-white/20"
      >
        <MdHome className="text-xl" />
      </Link>

      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-xs font-semibold text-white backdrop-blur-sm">
            🆕 Novedad
          </span>

          <h1 className="mt-5 text-4xl font-bold leading-tight text-white md:text-5xl">
            Ahora puedes usar Almacenes Digitales desde tu computador
          </h1>

          <p className="mt-5 text-lg text-white/80">
            Descarga la nueva app de escritorio y gestiona tu negocio sin depender del navegador:
            más rápida, siempre a un clic y con toda tu información sincronizada.
          </p>

          <div className="mt-8 flex flex-col items-start gap-3">
            <a
              href={DESKTOP_APP_DOWNLOAD_URL}
              download
              onClick={handleDownloadClick}
              className="group inline-flex items-center gap-3 rounded-xl bg-[#FF6B00] px-10 py-5 text-lg font-bold text-white shadow-xl shadow-black/20 transition-all hover:-translate-y-0.5 hover:bg-[#FF4A00] hover:shadow-2xl active:bg-[#E64200]"
            >
              <FaWindows className="text-2xl" />
              Descargar para Windows
            </a>
            <p className="text-sm text-white/60">
              Windows 10 / 11 · 64 bits · v{DESKTOP_APP_VERSION} · Gratis
            </p>
          </div>

        </div>

        <div className="hidden justify-center lg:flex">
          <div className="rounded-3xl border border-white/20 bg-white/10 p-8 shadow-2xl backdrop-blur-md">
            <img
              src={pcstoreIllustration}
              alt="Almacenes Digitales en tu computador"
              className="w-full max-w-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
